import { RadioGroup as HeadlessUiRadioGroup } from '@headlessui/react';

import Props from '@/components/@base/input/radio/type';

export default function RadioGroup({ children, ...props }: Props) {
  return <HeadlessUiRadioGroup {...props}>{children}</HeadlessUiRadioGroup>;
}
